import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import './MainComponents.css'

export default function BackButton(props) {
    let lightclass = (props.lightcta != true) ? '' : 'lightcta'
    return (
        <div className={'backbtn noselect ' + props.className}>

            <br /><br />
            <a href={props.href}><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a>


        </div >
    )
}